import { AddressDetails, AddressFetch, AddressSearch, Prediction } from '../../api';
import { MapsApi } from '../../api/maps/mapsApi';
import { configuration } from '../../configuration';

export class AddressService {
  private readonly mapsApi = new MapsApi();

  public initializeRecaptcha() {
    const scriptId = 'liquid-recaptcha';
    const isRecaptchaLoaded = document.getElementById(scriptId);

    if (isRecaptchaLoaded) return true;

    const script = document.createElement('script');

    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${configuration.recaptchaV3SiteKey}`;
    script.id = scriptId;
    script.async = true;
    document.body.appendChild(script);

    return true;
  }

  public async search(address: AddressSearch): Promise<Prediction[]> {
    this.initializeRecaptcha();
    return this.mapsApi.getPlacePredictions(address.search);
  }

  public async get(address: AddressFetch): Promise<AddressDetails> {
    this.initializeRecaptcha();
    return await this.mapsApi.getPlaceDetails(address.placeId);
  }
}
